/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [anonymous.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 15.01.19 19:30
 */

import axios from 'axios';
import {
    environment as env,
    getFetchSpacesEventType,
    getPublicCurrentDateSpacesUrl,
    getPublicParentSpacesUrl
} from "./environment";

import {
    asyncHandleError,
    FETCH_CHAT_COUNT,
    FETCH_CHAT_ENTRIES,
    FETCH_COMMENTS,
    FETCH_FOLLOWEES,
    FETCH_FOLLOWERS,
    FETCH_FRIENDS,
    FETCH_FRIENDS_PENDING,
    FETCH_LOGINDATA,
    FETCH_PAGE_SIZE,
    FETCH_POSTS,
    FETCH_POSTS_PAGE,
    FETCH_USERDATA,
} from "./index";

import {
    FETCH_ANY_SPACES,
    FETCH_GENERICDATA,
    FETCH_HOMEDATA,
    FETCH_MEMBERS,
    FETCH_MEMBERS_PAGE,
    FETCH_PAGE,
    FETCH_SPACE_MEDIA,
    FETCH_WIDGETS,
    SEARCH_GLOBAL
} from "./spaces";
import {redirectToErrorPage, redirectToPage} from "./error-handling";


export function anonymousFetchWidgets(username, position, callback) {
    return dispatch => {
        axios.get(`${env.ROOT_PUBLIC_URL}/${username}/widgets`)
            .then(response => {
                dispatch(fetchWidgets(response.data));
            })
            .catch(error => {
                logError(error);
            })
    };

    function fetchWidgets(widgets) {
        callback && callback(widgets);
        return {type: FETCH_WIDGETS, widgets}
    }
}

export function anonymousFetchPage(username, name, callback) {
    return dispatch => {
        axios.get(`${env.ROOT_PUBLIC_URL}/${username}/page/${name}`)
            .then(response => {
                dispatch(fetchPage(response.data));
            })
            .catch(error => {
                logError(error);
            })
    };

    function fetchPage(page) {
        callback && callback(page);
        return {type: FETCH_PAGE, page}
    }
}

export function anonymousSearchGlobal(username, term, size, callback) {
    return dispatch => {
        axios.get(`${env.ROOT_PUBLIC_URL}/${username}/search/${term}/${size}`)
            .then(response => {
                // quick hack for appending firstname and lastname to response  (required for getUserAvatar)
                //  - refactor on server - DONE
                // const searchResult = response.data.map(entry => {
                //     const names = entry.name.split(' ');
                //     return {...entry, firstname: names[0], lastname: names[1]}
                // });
                // dispatch(searchGlobal(searchResult));
                dispatch(searchGlobal(response.data));
            })
            .catch(error => {
                logError(error);
            })
    };

    function searchGlobal(result) {
        callback && callback(result);
        return {type: SEARCH_GLOBAL, result}
    }
}

export function anonymousFetchPosts(username, space) {

    return dispatch => {
        axios.get(`${env.ROOT_PUBLIC_URL}/${username}/posts/${space}`).then(response => {
            dispatch(fetchPosts(response.data))
        })
            .catch(error => {
                logError(error);
            });
    };

    function fetchPosts(posts) {
        return {type: FETCH_POSTS, posts}
    }
}

export function anonymousFetchPostsPage(username, space, page, size = FETCH_PAGE_SIZE, callback) {

    return dispatch => {
        axios.get(`${env.ROOT_PUBLIC_URL}/${username}/posts/${space}/page/${page}/${size}`)
            .then(response => {
                dispatch(fetchPostsPage(response.data))
            })
            .catch(error => {
                logError(error);
            });
    };

    function fetchPostsPage(page) {
        callback && callback(page);
        return {type: FETCH_POSTS_PAGE, page}
    }
}

export function anonymousFetchLoginData(username) {

    return dispatch => {
        axios.get(`${env.ROOT_PUBLIC_URL}/${username}/userdata`).then(response => {
            dispatch(fetchLoginData(response.data))
        })
            .catch(error => {
                logError(error);
            })
    };

    function fetchLoginData(userdata) {
        return {type: FETCH_LOGINDATA, userdata}
    }
}

export function anonymousFetchUserData(username, callback) {

    return dispatch => {
        axios.get(`${env.ROOT_PUBLIC_URL}/${username}/userdata`).then(response => {
            dispatch(fetchUserData(response.data))
        })
            .catch(error => {
                logError(error);
            })
    };

    function fetchUserData(userdata) {
        callback && callback(userdata);
        return {type: FETCH_USERDATA, userdata}
    }
}

export function anonymousFetchComments(username, id, callback) {
    return dispatch => {
        axios.get(`${env.ROOT_PUBLIC_URL}/${username}/comments/${id}`).then(response => {
            dispatch(fetchComments(response.data, id));
        })
            .catch(error => {
                logError(error);
            });
    };

    function fetchComments(comments, postId) {
        callback && callback(comments, postId);
        return {type: FETCH_COMMENTS, comments, id: postId}
    }
}

export function anonymousFetchFriends(username, callback) {
    return dispatch => {
        axios.get(`${env.ROOT_PUBLIC_URL}/${username}/friends`).then(response => {
            dispatch(fetchFriends(response.data));
        })
            .catch(error => {
                logError(error);
            });
    };

    function fetchFriends(friends) {
        callback && callback(friends);
        return {type: FETCH_FRIENDS, friends}
    }
}

/* noop */
export function anonymousFetchFriendsPending(username, callback) {
    return dispatch => {
        axios.get(`${env.ROOT_PUBLIC_URL}/${username}/friends/pending`).then(response => {
            dispatch(fetchFriendsPending(response.data));
        })
            .catch(error => {
                logError(error);
            });
    };

    function fetchFriendsPending(friends) {
        callback && callback(friends);
        return {type: FETCH_FRIENDS_PENDING, friends}
    }
}

/* noop */
export function anonymousFetchFollowers(username) {
    return dispatch => {
        axios.get(`${env.ROOT_PUBLIC_URL}/${username}/followers`).then(response => {
            dispatch(fetchFollowers(response));
        })
            .catch(error => {
                logError(error);
            })
    };

    function fetchFollowers(response) {
        return {type: FETCH_FOLLOWERS, payload: response}
    }
}

/* noop */
export function anonymousFetchFollowees(username) {
    return dispatch => {
        axios.get(`${env.ROOT_PUBLIC_URL}/${username}/followees`).then(response => {
            dispatch(fetchFollowees(response.data));
        })
            .catch(error => {
                logError(error);
            })
    };

    function fetchFollowees(followees) {
        return {type: FETCH_FOLLOWEES, followees}
    }
}

/* noop */
export function anonymousFetchChatEntries(username, chatId, callback) {

    return dispatch => {
        axios.get(`${env.ROOT_PUBLIC_URL}/${username}/chat/${chatId}/entries`).then(response => {
            dispatch(fetchChatEntries(response.data));
        })
            .catch(error => {
                logError(error);
            })
    };

    function fetchChatEntries(data) {
        if (callback !== undefined) {
            callback()
        }
        return {type: FETCH_CHAT_ENTRIES, payload: data}
    }
}

/* noop */
export function anonymousFetchChatCount(username, chatId, callback) {

    return dispatch => {
        axios.get(`${env.ROOT_PUBLIC_URL}/${username}/chat/${chatId}/count`).then(response => {
            dispatch(fetchChatCount(response.data));
        })
            .catch(error => {
                logError(error);
            })
    };

    function fetchChatCount(data) {
        if (callback !== undefined) {
            callback()
        }
        return {type: FETCH_CHAT_COUNT, payload: data}
    }
}

export function anonymousFetchGenericData(username, space, callback) {

    return dispatch => {
        axios.get(`${env.ROOT_PUBLIC_URL}/${username}/space/${space}`).then(response => {
            dispatch(fetchGenericData(response.data))
        })
            .catch(error => {
                logError(error);
            })
    };

    function fetchGenericData(genericdata) {
        callback && callback(genericdata);
        return {type: FETCH_GENERICDATA, genericdata}
    }
}

export function anonymousFetchHomeData(username, space, callback) {

    return dispatch => {
        axios.get(`${env.ROOT_PUBLIC_URL}/${username}/space/${space}`).then(response => {
            dispatch(fetchHomeData(response.data))
        })
            .catch(error => {
                logError(error);
            })
    };

    function fetchHomeData(homedata) {
        callback && callback(homedata);
        return {type: FETCH_HOMEDATA, homedata}
    }
}

export function anonymousFetchSpaceMedia(username, space, callback) {

    return dispatch => {
        axios.get(`${env.ROOT_PUBLIC_URL}/${username}/posts/media/${space}`).then(response => {
            dispatch(fetchMedia(response.data))
        })
            .catch(error => {
                logError(error);
            });
    };

    function fetchMedia(media) {
        callback && callback(media);
        return {type: FETCH_SPACE_MEDIA, media}
    }
}

export function anonymousFetchSpaceMediaByTypePaged(username, space, mediatype, page, size, callback) {

    return dispatch => {
        axios.get(`${env.ROOT_PUBLIC_URL}/${username}/posts/media/${space}/${mediatype}/${page}/${size}`)
        .then(response => {
            dispatch(fetchMedia(response.data))
        })
        .catch(error => {
            logError(error);
        });
    };

    function fetchMedia(media) {
        callback && callback(media);
        return {type: FETCH_SPACE_MEDIA, media}
    }
}

/**
 * type one of GENERIC|EVENT|SHOP , context = if defined, one of PUBLIC|VIEW (internal only, no server support)
 * resolves to (reducer):
 * generic spaces: FETCH_GENERIC|FETCH_GENERIC_PUBLIC|FETCH_GENERIC_VIEW,
 * event spaces: FETCH_EVENT|FETCH_EVENT_PUBLIC|FETCH_EVENT_VIEW
 **/
export function anonymousFetchSpaces(username, type, context, callback) {
    console.log('anonymousFetchSpaces', username, type, context)
    return dispatch => {
        axios.get(getPublicParentSpacesUrl(username, type))
            .then(response => {
                dispatch(fetchSpaces(response.data));
            })
            .catch(error => {
                logError(error);
            })
    };

    function fetchSpaces(data) {
        callback && callback(data);
        return {type: getFetchSpacesEventType(type, context), payload: data}
    }
}

export function anonymousFetchCurrentDateSpaces(username, type, callback) {
    return dispatch => {
        axios.get(getPublicCurrentDateSpacesUrl(username, type))
            .then(response => {
                dispatch(fetchCurrentDateSpaces(response.data));
            })
            .catch(error => {
                logError(error);
            })
    };

    function fetchCurrentDateSpaces(data, context) {
        callback && callback(data);
        return {type: getFetchSpacesEventType(type, context), payload: data}
    }
}

export function anonymousFetchAnySpaces(username) {
    return dispatch => {
        axios.get(`${env.ROOT_PUBLIC_URL}/${username}/spaces/*`).then(response => {
            dispatch(fetchAnySpaces(response.data));
        })
            .catch(error => {
                logError(error);
            })
    };

    function fetchAnySpaces(spaces) {
        return {type: FETCH_ANY_SPACES, spaces}
    }
}

export function anonymousFetchMembers(username, spaceId) {
    return dispatch => {
        axios.get(`${env.ROOT_PUBLIC_URL}/${username}/space/${spaceId}/members`).then(response => {
            dispatch(fetchMembers(response));
        })
            .catch(error => {
                logError(error);
            })
    };

    function fetchMembers(response) {
        return {type: FETCH_MEMBERS, payload: response.data}
    }
}

export function anonymousFetchMembersPage(username, spaceId, page, size, callback) {
    return dispatch => {
        axios.get(`${env.ROOT_PUBLIC_URL}/${username}/space/${spaceId}/members/${page}/${size}`)
            .then(response => {
                dispatch(fetchMembersPage(response.data));
            })
            .catch(error => {
                logError(error);
            })
    };

    function fetchMembersPage(page) {
        callback && callback(page);
        return {type: FETCH_MEMBERS_PAGE, page}
    }
}

function logError(error) {
    if (error && error.response && error.response.data) {
        const {data} = error.response;
        // notifyError(`${data.error}. ${data.message}. Status(${data.status})`);

        if (data.status === 404) {
            redirectToPage('/page-not-found', data);

        } else {
            window._isServerAlive_= false;
            console.log('SYSTEM ERROR (0)', error)
            redirectToPage('/error-page', data);
        }

    } else {
        console.log('SYSTEM ERROR (1)', error)
        window._isServerAlive_= false;
        redirectToErrorPage(error);
    }
}
